import type { FilterValues } from "./filter";


export const headers = [
  {
    key: "orderId",
    label: "Order ID",
  },
  {
    key: "customerName",
    label: "Customer Name",
  },
  {
    key: "orderDate",
    label: "Order Date",
  },
  {
    key: "totalAmount",
    label: "Total Amount",
  },
  {
    key: "partnerEarning",
    label: "My Earnings",
  },
  {
    key: "afpCommission",
    label: "AFP Commission",
  },
  {
    key: "status",
    label: "Payment Status",
  },
];

export interface ServiceListSearchAndFiltersProps {
  onSearch: (searchText: string) => void;
  onFilterChange: (filters: FilterValues) => void;
  onResetFilters?: () => void;
  filterValues: FilterValues;
  placeholder?: string;
  appliedFiltersCount?: number;
  isFilterOpen?: boolean;
  setIsFilterOpen?: (isOpen: boolean) => void;
  searchRef?: React.RefObject<{ clear: () => void; searchValue?: string } | null>;
  isReset?: boolean;
  localSearchText?: string;
  createServiceHandler?: () => void;
}
